<!--
 * @Author: your name
 * @Date: 2021-01-20 14:00:45
 * @LastEditTime: 2021-02-05 21:05:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/payment/component/AddTabDialog/index.vue
-->
<style scoped lang="sass">
.add_tab_dialog
  height: 100%
  width: 100%

.operation
  display: flex
  justify-content: center

.cancel_button
  flex: 1
  height: 52PX
  margin-right: 10PX
  color: var(--menu-primary-background-colour)
  background: #fff !important
  border: 1px solid var(--menu-primary-background-colour)

.sure_button
  flex: 1
  height: 52PX

.add_tab_container
  display: flex
  flex-direction: column

::v-deep
  .van-popup
    width: calc(100% - 80PX)
    transform: translate3d(-50%, -100%, 0)

.title
  line-height: 1
  font-size: 18PX
  text-align: center

.info
  line-height: 16PX
  font-size: 12PX
  text-align: center
  margin: 20PX 0 33PX 0
</style>

<template lang="pug">
.add_tab_dialog
  BottomPopupDialog(
    :show="show"
    :showCloseIcon="false"
    :position="'center'"
  )
    template(v-slot:popup-dialog)
      .add_tab_container
        .title.b {{ title }}
        .info.o7 {{ t('increase_tab_info', 'You are about to increase your tab from') }} {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ originPrice }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }} {{ t('to', 'to') }} {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ currentPrice }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}.
        .operation
          van-button.cancel_button.b(type="primary" @click="closeDialog") {{ cancelText }}
          van-button.sure_button.b(type="primary" @click="handleSure") {{ sureText }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { updateTab } from 'api/tab'
import { formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import { t } from '@/utils/language'

@Component({
  model: {
    prop: 'show',
    event: 'changeShow'
  },

  props: {
    show: {
      type: Boolean
    },
    currentTab: Object,
    orderAmount: [Number, String]
  },

  computed: {
    originPrice() {
      return this.currentTab?.tabAmount ? this.currentTab.tabAmount : 0
    },

    currentPrice() {
      const currentTab = this.currentTab
      const orderAmount = Number(this.orderAmount)
      const amount = currentTab?.isSetTabAmount ? orderAmount + Number(currentTab?.amount) : orderAmount + Number(currentTab?.tabAmount)
      return formatDecimalNumber(amount)
    },

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})

class AddTabDialog extends Vue {
  cancelText = t('cancel', 'CANCEL')
  sureText = t('ok', 'OK')
  title = t('add_to_tab', 'Add it to your tab?')

  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  handleSure() {
    this.$store.commit('showLoading')
    const requestData = {
      tabId: this.currentTab.id,
      venueId: this.currentTab.venueId,
      passCode: this.currentTab.phone.substr(-4),
      action: 'increaseTabAmount',
      detail: {
        tabAmount: this.currentPrice
      },
      fromPayment: true
    }
    updateTab(requestData).then(res => {
      this.$store.commit('closeLoading')
      this.$emit('payWithTab')
      this.closeDialog()
    }).catch(_ => {
      this.$store.commit('closeLoading')
    })
  }

  closeDialog() {
    this.$emit('changeShow', false)
  }
}

export default AddTabDialog
</script>
